import script from "./Pla08DeferimentoTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./Pla08DeferimentoTabPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__